import { NavigationRouteContext, ParamListBase, RouteProp } from '@react-navigation/native';
import React from 'react';
import { getAppProps } from '@/Navigation';
import { isWeb } from '@/common/device-info';

/**
 * 运行时判断，判断是否是SPA容器，非SPA容器不能使用navigation相关的api
 */
export default function useRoute<T extends RouteProp<ParamListBase, string>>(): T {
    const route = React.useContext(NavigationRouteContext);
    if (route) {
        // SPA
        return route as T;
    } else {
        // 兼容MPA
        let params = getAppProps();
        if (isWeb) {
            params = {
                ...params,
                ...Object.fromEntries(new URLSearchParams(new URL(window.location.href).search).entries()),
            };
        }
        return {
            key: params.componentName,
            name: params.componentName,
            params,
        } as T;
    }
}
